var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import RouterService from "@ember/routing/router-service";
import Transition from "@ember/routing/transition";
import Service, { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import SemeiaSessionService from "core/services/session";
let TermsOfUseService = (_class = class TermsOfUseService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "transition", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
    _initializerDefineProperty(this, "session", _descriptor3, this);
  }
  /**
   * The current version of Terms of Use that users (patient or medics) must have accepted, to be granted the app access
   */
  get currentVersion() {
    return 2.0;
  }

  /**
   * The limit date the user can indicate that he refuses the latest terms of use.
   */
  get limitDate() {
    return "08/11/2020";
  }
  redirectToAcceptTermsOfUseIfNeeded(acceptedTermsOfUseVersion, transition) {
    if (acceptedTermsOfUseVersion !== this.currentVersion) {
      // Store the transition only for useful routes, different than terms-of-use
      if (!transition.to?.name.includes("terms-of-use")) {
        this.transition = transition;
      }
      this.router.transitionTo("terms-of-use");
    }
  }
  continueNavigationAfterAcceptingTermsOfUse() {
    if (this.transition) {
      this.transition.retry();
      this.transition = undefined;
    } else {
      this.router.transitionTo("/");
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "transition", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TermsOfUseService as default };